/**
 * Context for blocking navigation when there are unsaved changes.
 * Used by Interaction page and BlockableLink (in Header).
 */

import { createContext, useContext, useState } from 'react';

const UnsavedChangesContext = createContext(null);

export function UnsavedChangesProvider({ children }) {
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  return (
    <UnsavedChangesContext.Provider value={{ hasUnsavedChanges, setHasUnsavedChanges }}>
      {children}
    </UnsavedChangesContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function useUnsavedChanges() {
  const ctx = useContext(UnsavedChangesContext);
  return ctx || { hasUnsavedChanges: false, setHasUnsavedChanges: () => {} };
}
